var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 148,
    viewBox: "0 0 126 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4395_2874)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4395_2874)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 15.5976C75.1614 20.1212 68.9461 24.6546 62.7356 29.183C62.1436 29.6146 61.5566 30.0412 60.9646 30.4727C59.8244 31.297 58.6939 32.1261 57.5537 32.9552C57.544 32.9552 57.5392 32.9697 57.5343 32.9746C57.4809 33.0133 57.4276 33.0521 57.3693 33.0958C55.6663 34.3321 53.9584 35.5782 52.2554 36.8194C42.5661 44.0921 29.6987 45.5224 18.8546 40.5043C7.20029 35.1127 -0.223177 23.1564 0.00486454 10.114H57.0248C57.772 10.114 58.5192 10.1285 59.2616 10.1576C59.5624 10.1673 59.8584 10.177 60.1592 10.1964C60.3581 10.2061 60.5522 10.2158 60.7511 10.2352C61.7506 10.2933 62.7453 10.3806 63.7399 10.497C66.9179 10.8558 70.062 11.4909 73.1284 12.4073C73.4487 12.5043 73.7689 12.6061 74.0891 12.7079C76.8208 13.5806 79.2516 14.5794 81.367 15.5976H81.3719Z",
    fill: "#00AD88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.71 85.2461C94.9476 101.421 77.8785 111.481 59.4363 111.355H38.7961C38.3061 106.492 37.7433 94.2691 44.6815 81.3624C47.0202 77.0134 49.7324 73.4643 52.3767 70.6279C53.5751 69.3431 54.759 68.1988 55.8895 67.1952C57.5198 65.7455 59.0287 64.5818 60.2902 63.6849C60.5134 63.52 60.7318 63.3746 60.9355 63.2291C62.8957 61.8424 64.8559 60.4606 66.8161 59.0788C78.4462 50.8703 90.086 42.6473 101.721 34.434C111.604 49.7406 112.376 69.2655 103.715 85.2558L103.71 85.2461Z",
    fill: "#00AD88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126 0L121.08 13.3576L110.969 40.8194L110.891 41.023L104.836 31.9079L101.721 34.4242C99.7025 30.9624 96.3983 26.2545 91.2213 21.823C87.8492 18.9333 84.5499 16.897 81.7989 15.4667L89.0574 10.6133L81.9153 0.174545L81.794 0H125.995H126Z",
    fill: "url(#paint0_linear_4395_2874)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.68,
    d: "M39.7228 13.7552H6.15228C6.65688 16.8146 7.89898 21.9055 11.3487 27.2242C15.633 33.8327 21.0865 37.3527 23.9492 38.9333C23.8958 36.4121 24.1287 30.9188 27.3844 25.1103C31.3969 17.9588 37.4958 14.783 39.718 13.7552H39.7228Z",
    fill: "url(#paint1_linear_4395_2874)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.68,
    d: "M102.279 45.8861C103.71 49.474 108.387 62.4582 103.177 77.4255C96.0733 97.8231 76.5976 104.689 74.1571 105.503C73.9387 99.0352 74.3657 85.9685 81.3379 71.5976C87.9269 58.0073 97.1892 49.8037 102.279 45.8909V45.8861Z",
    fill: "url(#paint2_linear_4395_2874)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M66.8112 59.0691C59.8196 75.8448 56.0545 104.015 55.1569 111.355H38.7913C38.3012 106.492 37.7384 94.2691 44.6767 81.3624C47.0153 77.0133 49.7275 73.4642 52.3718 70.6279C53.5703 69.343 54.7541 68.1988 55.8846 67.1952C57.5149 65.7455 59.0238 64.5818 60.2853 63.6849C60.5085 63.52 60.7269 63.3745 60.9307 63.2291C62.8908 61.8424 64.851 60.4606 66.8112 59.0788V59.0691Z",
    fill: "url(#paint3_linear_4395_2874)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M60.2854 63.68C53.6285 79.2582 50.2855 105.188 49.5626 111.355H38.7961C38.3061 106.492 37.7433 94.2691 44.6815 81.3624C47.0202 77.0133 49.7324 73.4643 52.3767 70.6279C53.5751 69.343 54.759 68.1988 55.8895 67.1952C57.5198 65.7455 59.0287 64.5818 60.2902 63.6849L60.2854 63.68Z",
    fill: "url(#paint4_linear_4395_2874)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3719 70.6279C47.6412 84.2085 45.1667 105.154 44.5069 111.355H38.7961C38.3061 106.492 37.7433 94.2691 44.6815 81.3624C47.0202 77.0133 49.7324 73.4642 52.3767 70.6279H52.3719Z",
    fill: "url(#paint5_linear_4395_2874)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M60.9646 30.4727C64.2106 20.5479 61.9399 13.6049 60.1641 10.1915C61.3625 10.2546 62.5512 10.3564 63.7399 10.4921C66.918 10.8509 70.062 11.4861 73.1284 12.4024C73.4487 12.4994 73.7689 12.6012 74.0891 12.703C76.8208 13.5758 79.2516 14.5746 81.367 15.5927C74.5646 20.5479 67.7622 25.5079 60.9598 30.4727H60.9646Z",
    fill: "url(#paint6_linear_4395_2874)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3719 15.5976C73.4341 21.3818 65.4915 27.1709 57.5537 32.96C69.5671 23.4715 66.5152 14.7443 63.7399 10.497C66.9179 10.8558 70.062 11.4909 73.1284 12.4073C73.4487 12.5043 73.7689 12.6061 74.0891 12.7079C76.8208 13.5806 79.2516 14.5794 81.367 15.5976H81.3719Z",
    fill: "url(#paint7_linear_4395_2874)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.44,
    d: "M126 0L121.08 13.3576C110.629 4.71758 87.6454 0.99394 81.9153 0.174545L81.794 0H125.995H126Z",
    fill: "url(#paint8_linear_4395_2874)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M126 -3.81004e-06L121.08 13.3576L110.969 40.8194C110.818 36.0824 110.304 10.9236 115.457 -0.00485229H126V-3.81004e-06Z",
    fill: "url(#paint9_linear_4395_2874)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.988 89.1588C19.728 92.3685 11.7951 97.2267 8.98096 105.571C8.26772 107.612 7.87472 109.566 7.68549 111.35C7.68549 111.35 7.57875 117.867 7.4429 125.401C7.25852 135.622 7.02563 147.714 6.93829 147.971C8.8257 148.048 14.6626 148.116 21.1399 145.232C21.038 140.504 20.9167 133.178 20.941 125.396C20.9701 115.05 21.2564 103.888 22.1734 96.9503C22.1879 96.8291 22.2073 96.7127 22.2268 96.5915C22.6101 93.8909 23.2505 91.3988 24.0511 89.1103C24.0317 89.1249 24.0123 89.1394 23.9929 89.1539L23.988 89.1588Z",
    fill: "url(#paint10_linear_4395_2874)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.513 70.1673C42.2895 76.3927 32.9301 82.4194 24.0462 89.1152C23.2408 91.3988 22.6052 93.8958 22.2219 96.5964C22.2025 96.7176 22.1831 96.834 22.1685 96.9552C21.2515 103.898 20.9652 115.055 20.9361 125.401C20.9119 133.183 21.0332 140.509 21.135 145.236C22.023 144.844 22.9254 144.388 23.8327 143.879C25.1282 143.137 26.4334 142.269 27.724 141.251C27.9666 141.062 28.1995 140.868 28.4324 140.674C33.1484 136.703 36.3556 131.316 37.7918 125.406C38.3061 123.282 38.602 121.091 38.6457 118.875L38.7961 111.355C38.3061 106.492 37.7432 94.2691 44.6815 81.3624C48.0779 75.0352 52.2796 70.4049 55.8895 67.1952C54.4388 68.1939 52.9783 69.1879 51.5179 70.1721L51.513 70.1673Z",
    fill: "url(#paint11_linear_4395_2874)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4395_2874",
    x: -2.50024,
    y: -0.504852,
    width: 133,
    height: 155,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4395_2874"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4395_2874",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4395_2874",
    x1: 67.4662,
    y1: 43.84,
    x2: 138.963,
    y2: -13.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#28376E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000D2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4395_2874",
    x1: 4.71611,
    y1: 13.5273,
    x2: 30.7885,
    y2: 25.8665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F8F8F8",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E7E7",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CACACA",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A1A1A1",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6D6D6D",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2F2F2F",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4395_2874",
    x1: 109.406,
    y1: 46.6521,
    x2: 77.1311,
    y2: 100.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F8F8F8",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E7E7E7",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CACACA",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#A1A1A1",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6D6D6D",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2F2F2F",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4395_2874",
    x1: 52.3621,
    y1: 83.617,
    x2: 39.5653,
    y2: 134.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28376E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000D2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4395_2874",
    x1: 42.5079,
    y1: 115.35,
    x2: 54.3111,
    y2: 58.4403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AD88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4395_2874",
    x1: 39.8005,
    y1: 114.255,
    x2: 49.6559,
    y2: 66.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AD88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4395_2874",
    x1: 74.4579,
    y1: 8.58183,
    x2: 57.8924,
    y2: 27.9777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AD88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4395_2874",
    x1: 75.6563,
    y1: 9.42062,
    x2: 56.3275,
    y2: 32.0524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AD88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4395_2874",
    x1: 87.2961,
    y1: 17.7115,
    x2: 126.6,
    y2: -13.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28376E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000D2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4395_2874",
    x1: 107.524,
    y1: 44.1552,
    x2: 123.558,
    y2: -10.1589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28376E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000D2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4395_2874",
    x1: 5.00237,
    y1: 159.35,
    x2: 48.8501,
    y2: 10.8291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28376E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000D2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4395_2874",
    x1: -11.2759,
    y1: 251.408,
    x2: 54.0814,
    y2: 30.0014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000D2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28376E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4395_2874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 148,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e8cb640dfd4fb44c3b4946cbb0beb926.svg";
export { ForwardRef as ReactComponent };